@import '../../constants/screen-width-breakpoints.module.less';
@import '../../constants/z-index.module.less';
@import '../../constants/transitions.module.less';
@import '../../constants/mixins.module.less';

.drawer-container {
  position: fixed;
  inset: 0;
  overflow: hidden;
  transition: right @transition-sidebar-shift;
  z-index: @z-order-details-drawer;
  .shift-for-sidebar();
}

.drawer-background {
  position: fixed;
  inset: 0;
  background-color: var(--dark--background-color--2);
  transition: right @transition-sidebar-shift;
  z-index: @z-order-details-drawer;
}

.drawer {
  position: fixed;
  inset: 64px 0 0;
  display: flex;
  flex-flow: column nowrap;
  border-radius: 8px 8px 0 0;
  border-width: 1px 1px 0;
  border-style: solid;
  border-color: var(--default--border-color--12);
  overflow: hidden;
  animation: slidein 250ms ease-out;
  transition: right @transition-sidebar-shift;
  z-index: @z-order-details-drawer;
  .shift-for-sidebar();
}

@media (max-height: 832px) {
  .drawer {
    top: 16px;
  }
}

@keyframes slidein {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
}
